import { useState } from 'react'
import { useTickets } from 'store/useTickets'
import { useTranslation } from 'utils/useTranslation'
import { Header, TabHistory, Tabs, TabUpcoming } from './components'
import { TicketTabType } from './types'

export const TicketsPage = () => {
  const intl = useTranslation()
  const { tickets, isLoadingTickets } = useTickets()
  const [currentTab, setCurrentTab] = useState<TicketTabType>({
    name: intl({
      id: 'ticket.upcomingVisits',
    }),
    current: true,
  })

  return (
    <div className='bg-custom-bg pb-[80px] md:pb-[20px]'>
      <Header />
      <Tabs currentTab={currentTab} onChange={tab => setCurrentTab(tab)} />
      {currentTab?.name ===
        intl({
          id: 'ticket.upcomingVisits',
        }) && <TabUpcoming tickets={tickets} isLoading={isLoadingTickets} />}
      {currentTab?.name ===
        intl({
          id: 'ticket.visitsHistory',
        }) && <TabHistory tickets={tickets} isLoading={isLoadingTickets} />}
    </div>
  )
}
